export const cardActionStyle = {
  zIndex: 2,
  display: "inline-block",
  float: "right"
};
